import { CustomerMaterial } from "components/Sales/CustomerMaterial";
import React from 'react'
import { Avatar, Breadcrumb, Button, Card, Icon, Layout, Row, Select, Tabs } from 'antd'
import SuppliersApi from '../../api/Purchase/Suppliers'
import style from './style.css'
import { Link } from 'react-router-dom'
import CustomTable from '../../elements/Table/CustomTable'
import _, { get } from 'lodash'
import { streamUrl } from '../../variables/index'
import Status from '../../elements/Status'
import { dateFormat, filterCheckedColumns, sessionItemVal, strVal } from '../../modules/Utils'
import moment from 'moment'
import State from '../../elements/State'
import ContractsApi from '../../api/Purchase/PurchaseContracts'
import InfoText from '../../elements/InfoText'
import Auth from '../../modules/Authentication'
import useFetchList from '../../elements/Hooks/useFetchList'

import useTitle from '../../elements/Hooks/useTitle'
import BoolFilter from '../../elements/Select/BoolFilter'
import BoolCell from '../../elements/Table/Cells/BoolCell'

const { Content } = Layout
const { TabPane } = Tabs
const api = new SuppliersApi()
const purchaseContractsApi = new ContractsApi()
const auth = new Auth()

const columns = [
  {
    Header: 'ID',
    accessor: '_id',
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Code',
    accessor: 'code',
    width: 100,
    Cell: ({ value, original }) => (
      <a onClick={() => (window.location = `#/purchasing/suppliers/${original.p_key}/`)}>
        {get(original, 'image') ? (
          <Avatar src={`${streamUrl}files/${original.image}?action=view&access_token=${auth.getAccessToken()}`} />
        ) : (
          <Avatar icon="global" />
        )}
        <span style={{ marginLeft: '10px' }}>{value}</span>
      </a>
    ),
  },
  {
    Header: 'Full Name',
    accessor: 'fn',
  },
  {
    Header: 'Trade Name',
    accessor: 'tradeName',
  },
  {
    Header: 'Phone Number',
    accessor: 'phone.label',
    width: 150,
  },

  {
    Header: 'Location',
    accessor: 'location',
    width: 150,
  },
  {
    Header: 'Status',
    accessor: 'status',
    width: 100,
    Cell: ({ value }) => value && <Status value={value} tooltip={false} />,
    filterMethod: (filter, row) => {
      const activeArray = ['Active']
      const nonActiveArray = ['Inactive']
      if (filter.value === 'all') {
        return true
      }
      return filter.value === true ? activeArray.includes(row[filter.id]) : nonActiveArray.includes(row[filter.id])
    },
    Filter: ({ onChange, filter }) => (
      <Select onChange={(value) => onChange(value)} style={{ width: '100%' }} value={filter ? filter.value : 'all'}>
        <Select.Option value="all">All</Select.Option>
        <Select.Option value={true}>Active</Select.Option>
        <Select.Option value={false}>None Active</Select.Option>
      </Select>
    ),
  },
]
const subColumns = [
  {
    Header: 'ID',
    accessor: '_id',
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Code',
    accessor: 'code',
    width: 150,

    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/purchasing/suppliers/${strVal(original, 'supplier._key')}/contracts/${
            original._key
          }/view`,
        }}
        style={{ marginLeft: '10px' }}>
        {value}
      </Link>
    ),
  },
  {
    Header: 'Supplier',
    accessor: 'supplier.fn',
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `#/purchasing/suppliers/${original.p_key}/`,
        }}
        style={{ marginLeft: '10px' }}>
        {value}
      </Link>
    ),
  },
  {
    Header: 'Business Registration',
    accessor: 'client.companyno',
  },
  {
    Header: 'Tax Registration',
    accessor: 'client.taxRegistration',
  },
  {
    Header: 'Company',
    accessor: 'company.fn',
  },
  {
    Header: 'Title',
    accessor: 'title',
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Type',
    accessor: 'type',
    Cell: ({ value }) => _.upperFirst(value),
    hideable: true,
    hideDefault: false,
  },
  {
    Header: 'Default',
    accessor: 'default',
    hideable: true,
    hideDefault: true,
    filterMethod: filterCheckedColumns,
    Filter: BoolFilter,
    Cell: BoolCell,
  },
  {
    Header: 'Center',
    accessor: 'center.name',
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Expiry Date',
    accessor: 'date.expiry',
    Cell: ({ value }) => value && dateFormat(moment(value)),
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Services State',
    accessor: 'state',
    width: 150,
    Cell: ({ value }) => value && <State value={sessionItemVal('general_state_dropdown', value)} tooltip={false} />,
  },
  {
    Header: 'Billing State',
    accessor: 'billingState',
    width: 150,
    Cell: ({ value }) => value && <State value={sessionItemVal('general_state_dropdown', value)} tooltip={false} />,
  },
  {
    Header: 'Document Status',
    accessor: 'status',
    width: 150,
    Cell: ({ value }) => <Status value={value} tooltip={false} />,
    filterMethod: (filter, row) => {
      const activeArray = ['Approved']
      const revisionArray = ['Draft', 'Submitted', 'Resubmitted', 'Revised']
      const nonActiveArray = ['Rejected', 'Closed', 'Cancelled']
      if (filter.value === 'all') {
        return true
      }
      if (filter.value === 'revision') {
        return revisionArray.includes(row[filter.id])
      }
      return filter.value === true ? activeArray.includes(row[filter.id]) : nonActiveArray.includes(row[filter.id])
    },
    Filter: ({ onChange, filter }) => (
      <Select onChange={(value) => onChange(value)} style={{ width: '100%' }} value={filter ? filter.value : true}>
        <Select.Option value="all">All</Select.Option>
        <Select.Option value={true}>Active</Select.Option>
        <Select.Option value="revision">In Progress</Select.Option>
        <Select.Option value={false}>None Active</Select.Option>
      </Select>
    ),
  },
]

function Suppliers(props) {
  const { list, fetching, fetch } = useFetchList(api.list)
  const { list: contracts, fetching: fetchingContracts, fetch: fetchContracts } = useFetchList(
    purchaseContractsApi.list
  )
  useTitle('Suppliers')
  return (
    <Content style={{ margin: '0px 0px' }}>
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Purchasing</Breadcrumb.Item>
            <Breadcrumb.Item>Vendor List</Breadcrumb.Item>
          </Breadcrumb>
          <h2 className={style.title}>Vendors</h2>
          <p className={style.paragraph}>List of all Vendors in system. You can filter or create a new supplier.</p>
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <Tabs defaultActiveKey={get(props, 'location.hash') || '#users'} onChange={(key) => props.history.push(key)}>
          <TabPane
            tab={
              <span>
                <Icon type="user" />
                Vendor Listing
              </span>
            }
            key="#users">
            <CustomTable
              defaultSorted={[
                {
                  id: 'fn',
                  desc: false,
                },
              ]}
              isFilterable={true}
              CreateButton={() => (
                <Button
                  onClick={() => {
                    props.history.push({
                      pathname: `/purchasing/suppliers/new`,
                    })
                  }}
                  type={'primary'}
                  size="small"
                  icon={'plus'}>
                  New
                </Button>
              )}
              columns={columns}
              data={list}
              fetching={fetching}
              fetch={fetch}
            />
          </TabPane>
          <TabPane
            tab={
              <span>
                  <Icon type="windows"/> Material Search
                </span>
            }
            key="#customermaterial">
            <CustomerMaterial type={'vendorQuote'}/>
          </TabPane>
          <TabPane
            tab={
              <span>
                <Icon type="book" />
                Vendors Accounts
              </span>
            }
            key="#contracts">
            <CustomTable
              isFilterable={true}
              defaultSorted={[
                {
                  id: 'supplier.fn',
                  desc: false,
                },
              ]}
              defaultFiltered={[
                {
                  id: 'status',
                  value: true,
                },
              ]}
              columns={subColumns}
              data={contracts}
              fetching={fetchingContracts}
              fetch={fetchContracts}
            />
            <InfoText text={'Click on contract code to view contracts.'} />
          </TabPane>
        </Tabs>
      </Card>
    </Content>
  )
}

Suppliers.propTypes = {}
Suppliers.defaultProps = {}

export default Suppliers
